import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import MemberActions, { memberActionTypes } from '@Actions/memberActions';
import TrackerActions from '@Actions/trackerActions';
import MemberServices from '@Services/memberServices';

/**
 * @param action
 */
function* _getMembers(action) {
  try {
    yield put(MemberActions.getMembersLoading(true));
    const members = yield MemberServices.getMembers();
    yield put(MemberActions.getMembersSuccess(members));
    yield put(MemberActions.getMembersLoading(false));
    if (action?.callback) {
      action.callback(members);
    }
  } catch (error) {
    yield put(MemberActions.getMembersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(memberActionTypes.GET_MEMBERS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getMembers() {
  yield takeLatest(memberActionTypes.GET_MEMBERS.REQUEST, _getMembers);
}

/**
 * @param action
 */
function* _createMember(action) {
  try {
    yield put(MemberActions.createMemberLoading(true));
    const createdMember = yield MemberServices.createMember(action.payload);
    if (!createdMember.success) {
      notification.open({
        type: 'error',
        message: createdMember?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: createdMember.message,
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(MemberActions.createMemberLoading(false));
  } catch (error) {
    yield put(MemberActions.createMemberLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(memberActionTypes.CREATE_MEMBER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createMember() {
  yield takeLatest(memberActionTypes.CREATE_MEMBER.REQUEST, _createMember);
}

/**
 * @param action
 */
function* _updateMember(action) {
  try {
    yield put(MemberActions.updateMemberLoading(true));
    const updatedMember = yield MemberServices.updateMember(action.payload);
    if (updatedMember.success) {
      notification.open({
        type: 'success',
        message: 'Member updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updatedMember.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MemberActions.updateMemberLoading(false));
  } catch (error) {
    yield put(MemberActions.updateMemberLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(memberActionTypes.UPDATE_MEMBER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateMember() {
  yield takeLatest(memberActionTypes.UPDATE_MEMBER.REQUEST, _updateMember);
}

/**
 * @param action
 */
function* _deleteMember(action) {
  try {
    yield put(MemberActions.deleteMemberLoading(true));
    const deletedMember = yield MemberServices.deleteMember(action.userId);
    if (deletedMember.message) {
      notification.open({
        type: 'error',
        message: deletedMember.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Member deleted successfully',
        duration: 4,
        placement: 'top',
      });
      const members = yield MemberServices.getMembers(action.memberId, null);
      yield put(MemberActions.getMembersSuccess(members));
    }
    yield put(MemberActions.deleteMemberLoading(false));
  } catch (error) {
    yield put(MemberActions.deleteMemberLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(memberActionTypes.DELETE_MEMBER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* deleteMember() {
  yield takeLatest(memberActionTypes.DELETE_MEMBER.REQUEST, _deleteMember);
}

/**
 * @param action
 */
function* _getTenantsRoles(action) {
  try {
    yield put(MemberActions.getTenantsRolesLoading(true));
    const tenantsRoles = yield MemberServices.getTenantsRoles();
    yield put(MemberActions.getTenantsRolesSuccess(tenantsRoles));
    yield put(MemberActions.getTenantsRolesLoading(false));
    if (action?.callback) {
      action.callback(tenantsRoles);
    }
  } catch (error) {
    yield put(MemberActions.getTenantsRolesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(memberActionTypes.GET_TENANTS_ROLES.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getTenantsRoles() {
  yield takeLatest(memberActionTypes.GET_TENANTS_ROLES.REQUEST, _getTenantsRoles);
}

/**
 *
 */
export default function* memberSaga() {
  yield all([
    getMembers(),
    deleteMember(),
    updateMember(),
    createMember(),
    getTenantsRoles(),
  ]);
}